import * as React from 'react';

interface CardProps {
    name: string,
    link: string,
}

export class Card extends React.Component<CardProps> {
    public render() {
        return (
            <div className={"card"}>
                <a href={this.props.link}>{this.props.name}</a>
                <hr/>
            </div>
        )
    }
}